export default __webpack_public_path__ + "static/media/ua.78095eb4.svg";